import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import FAQ from './components/FAQ';

const AppFooter = (props) => {
    const [showFAQ, setShowFAQ] = useState(false);

    return (
        <div className="layout-footer">
            <div className="footer-logo-container">
                <img id="footer-logo" src={`/assets/layout/images/logo-icon-${props.colorScheme === 'light' ? 'dark' : 'light'}.png`} alt="vault-layout" />
                <span className="app-name">VAULT</span>
            </div>
            <div className="footer-content">
                <Button 
                    icon="pi pi-question-circle" 
                    label="Yardım" 
                    className="p-button-text" 
                    onClick={() => setShowFAQ(true)} 
                />
                <span className="copyright">&#169; VAULT - 2023</span>
            </div>

            <Dialog 
                header="Yardım Merkezi" 
                visible={showFAQ} 
                onHide={() => setShowFAQ(false)}
                style={{ width: '50vw' }}
                breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            >
                <FAQ />
            </Dialog>
        </div>
    );
};

export default AppFooter;
